import React, { useEffect, useState } from 'react';
import { LinkLicense, getAllHardware, listLicenses } from '../../services/service';
import MenuItem from '@mui/material/MenuItem';
import './ListPageStyles.css'
import { APISelectField } from '../APISelectField';
import { FormDialog } from '../../components/FormDialog';

// const validationSchema = Yup.object({
//   name: Yup
//     .string('Insira o nome do Modelo da Licença')
//     .required('Campo obrigatório'),
//   durationUnit: Yup.string()
//     .oneOf(['lifetime', 'years', 'months', 'days'])
//     .required('Necessário escolher a unidade da duração!'),
// })



export default function LinkLicenseModal({ pageSize, licenseData, openModal, setOpenModal, onLicenseChanged, choseLicenseData, setChoseLicense }) {
    const [loading, setLoading] = useState(false);
    const [hardwareData, setHardwareData] = useState([])
    const [allLicenseData, setAllLicenseData] = useState([])
    const [selectedHardware, setSelectedHardware] = useState([])
    const [selectedLicense, setSelectedLicense] = useState([])

    const data = choseLicenseData ? {
        hardware_key: selectedHardware.value,
        // hardware:selectedHardware.value.id, 
        license: selectedLicense.value
    } : {
        hardware_key: selectedHardware.value,
        license: licenseData.id
    }

    const LinkLicenseAndCloseModal = () => {
        setLoading(true)
        LinkLicense(data).then((resp) => {
            console.log(resp)
            setOpenModal(false)
            onLicenseChanged()
        })
        .catch(err => {
            console.log(err.response)
        })
        .finally(() => {
            setLoading(false)
        })
    }
    const handleClose = () => {
        setOpenModal(false);
        setChoseLicense(false)

    };
    const handleChangeHardware = (e) => {
        setSelectedHardware(e.target)
    }
    const handleChangeLicense = (e) => {
        setSelectedLicense(e.target)
    }

    useEffect(() => {
        var filters = {
            license_linked: false
        }
        getAllHardware(filters).then((resp) => {
            setHardwareData(resp.data.results)
        }).catch(
            setHardwareData([])
        )
    }, [getAllHardware])

    useEffect(() => {
        const filter = { expand: "license_type,company" }
        listLicenses(1, pageSize, filter).then((resp) => {
            setAllLicenseData(resp.data.results)
        })
    }, [getAllHardware])

    if (choseLicenseData === true) {
        return (
            <div>
                <FormDialog
                    title={"Vincular Hardware e Licença"}
                    open={openModal}
                    onDismiss={handleClose}
                    formWidth={350}
                    onSubmit={LinkLicenseAndCloseModal}
                    loading={loading}
                >
                    <APISelectField
                        labelId="demo-simple-select-standard-label"
                        id="demo-simple-select-standard"
                        onChange={handleChangeLicense}
                        label="Name"
                    >
                        {allLicenseData.map((e) =>
                            e.is_linked === false
                                ? <MenuItem value={e.id}>{e.license_type.name}</MenuItem>
                                : null
                        )}
                    </APISelectField>
                    <APISelectField
                        labelId="demo-simple-select-standard-label"
                        id="demo-simple-select-standard"
                        onChange={handleChangeHardware}
                        label="Hardware Disponíveis"
                        disabled={hardwareData.length === 0 ? true : false}
                    >
                        {hardwareData.map((e) =>
                            <MenuItem value={e.hardware_key}>{e.name}</MenuItem>
                        )}
                    </APISelectField>
                </FormDialog>
            </div>
        );
    }
    else {
        return (
            <div>
                <FormDialog
                    title={
                        <>
                            Defina o Hardware no qual a licença <strong> {licenseData.id} ({licenseData.license_type}) </strong> irá se vincular.
                        </>
                    }
                    open={openModal}
                    onClose={handleClose}
                    aria-labelledby="modal-modal-title"
                    aria-describedby="modal-modal-description"
                    onSubmit={LinkLicenseAndCloseModal}
                >
                    {/* <TextField
                        id="name"
                        label="Licença"
                        disabled={true}
                        value={licenseData.id}
                        variant="standard"
                        size="small"
                    /> */}
                    <APISelectField
                        labelId="demo-simple-select-standard-label"
                        id="demo-simple-select-standard"
                        onChange={handleChangeHardware}
                        label="Hardware Disponíveis"
                    >
                        <MenuItem value="">
                            <em>Todas</em>
                        </MenuItem>
                        {hardwareData.map((e) =>
                            <MenuItem value={e.hardware_key}>{e.name}</MenuItem>
                        )}
                    </APISelectField>
                </FormDialog>
            </div>
        );
    }
}
